import { api, saveBlob } from './client';

// -- student plans -----------------------------------------------------------
// Paths are inlined rather than added to endpoints.js while the feature lands;
// they mirror `/students/me/billing` in the backend's docs/api.md.
const BASE = '/students/me/billing';

/** The plan, this month's usage and any unpaid invoice. Always has a plan. */
export function getBilling() {
  return api.get(BASE);
}

export function listPlans() {
  return api.get(`${BASE}/plans`);
}

// Moves to another plan: an upgrade (or a switch to another currency) starts
// now with an invoice; a downgrade is scheduled for period end; the free plan
// ends the paid one at period end. The response says which happened
// (`effective_immediately`, `effective_at`) — the screen never assumes it.
export function changePlan(planCode, couponCode) {
  return api.post(`${BASE}/change-plan`, {
    plan_code: planCode,
    ...(couponCode ? { coupon_code: couponCode } : {}),
  });
}

/** The original name of `changePlan`; the API keeps `/subscribe` as an alias. */
export const subscribe = changePlan;

// Prices a student coupon against a plan and spends nothing; the code is only
// claimed by `subscribe`.
export function previewCoupon(code, planCode) {
  return api.post(`${BASE}/coupon/preview`, { code, plan_code: planCode });
}

/** Ends the plan at period end, or withdraws an unpaid request. */
export function cancel() {
  return api.post(`${BASE}/cancel`);
}

/** Keeps the current plan: undoes a pending cancellation or downgrade. */
export function resume() {
  return api.post(`${BASE}/resume`);
}

export function listInvoices(params) {
  return api.getPaginated(`${BASE}/invoices`, { params });
}

export function getInvoice(id) {
  return api.get(`${BASE}/invoices/${id}`);
}

/** Saves the invoice PDF; the download carries the bearer token. */
export async function downloadInvoicePdf(invoice) {
  const { blob, filename } = await api.download(`${BASE}/invoices/${invoice.id}/pdf`);
  saveBlob(blob, filename.endsWith('.pdf') ? filename : `${invoice.number}.pdf`);
}
